// Project
import request from "../request";

/**
 * @param {string} resource
 */
export const getResourceRoles = async (resource) => {
	const response = await request({
		url: `logan/resource-roles?resource=${resource}`,
	});

	return response.data;
};

/**
 * @param {string} resource
 * @param {string} resourceId
 */
export const getRebacPolicies = async (resource, resourceId) => {
	const response = await request({
		url: `logan/resource-policies?resource=${resource}&resource_id=${resourceId}`,
	});

	return response.data;
};

/**
 * @param {Object} params
 * @param {string} params.userId
 * @param {string} params.resourceType
 * @param {string} params.resourceId
 * @param {string} params.relationship
 * @param {Date} [params.validUntil]
 */
export const upsertRebacPolicy = async (params) => {
	const { userId, resourceType, resourceId, relationship, validUntil } = params;

	const response = await request({
		url: "logan/resource-policies",
		method: "POST",
		data: {
			user_id: userId,
			resource_type: resourceType,
			resource_id: resourceId,
			relationship,
			validUntil: validUntil ? validUntil : undefined,
		},
	});

	return response.data;
};

/**
 * @param {string} policyId
 */
export const deleteRebacPolicy = async (policyId) => {
	const response = await request({
		url: `logan/resource-policies/${policyId}`,
		method: "DELETE",
	});

	return response.data;
};
